<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :disabled="!!solicitante"
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :disabled="!!solicitante"
                    :options="data.form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-checkbox
                    :label="false"
                    v-model="model.isPpi"
                >
                    PPI
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="model.atendeOutroMunicipio">
                    Atende outro município
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }

        if (this.solicitante) {

            this.loadSolicitante()
        }
    },
    data: () => ({
        model: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            isPpi: false,
            atendeOutroMunicipio: false,
            reguladores: [],
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadSolicitante() {

            Object.assign(this.model, this.solicitante)

            this.loadInfraestruturas()
        },
        handleUnidadeChange() {

            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (this.model.unidadeId) {

                this.loadInfraestruturas()
            }
        },
        loadInfraestruturas() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {

                    this.data.form.infraestruturas = data

                    if (this.data.form.infraestruturas.length === 1) {

                        this.model.infraestruturaId = this.data.form.infraestruturas[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (!this.solicitante && this.infraestruturaJaAdicionada()) {

                        this.showValidationNotification('O local de atendimento já foi incluído.')

                        return
                    }

                    if (this.solicitante) {

                        Object.assign(this.originalSolicitante, this.prepareData())
                    }
                    else {

                        this.data.model.solicitantes.push(this.prepareData())
                    }

                    this.$emit('save')
                })
        },
        infraestruturaJaAdicionada() {

            return !!this.data.model.solicitantes.find(s => s.infraestruturaId === this.model.infraestruturaId)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.unidadeNomeFantasia = this.data.form.unidades.find(u => u.id === data.unidadeId).nomeFantasia
            data.infraestruturaNome = this.data.form.infraestruturas.find(u => u.id === data.infraestruturaId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalSolicitante: { type: Object },
        solicitante: { type: Object },
    },
}
</script>